module.exports = __webpack_public_path__ + "img/seismic.f9c7febc.jpg";